
import { computed } from '@nuxtjs/composition-api';
import { PURCHASE_CATEGORY } from '~/constants/PurchaseCategory';
export default {
  props: {
    inStock: {
      type: Boolean,
      default: null
    },
    purchaseCategory: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    return {
      text: computed(() => {
        if (props.purchaseCategory === PURCHASE_CATEGORY.PRE_ORDER) {
          return 'Kommer snart'
        } else if (props.purchaseCategory === PURCHASE_CATEGORY.BACK_ORDER) {
          return 'Midlertidig udsolgt'
        }
        return props.inStock ? 'På lager' : 'Ikke på lager'
      }),
      color: computed(() => {
        if (props.purchaseCategory === PURCHASE_CATEGORY.PRE_ORDER) {
          return 'tertiary lighten-1'
        } else if (props.purchaseCategory === PURCHASE_CATEGORY.BACK_ORDER) {
          return 'warning'
        }
        return props.inStock ? 'quinary' : 'gray'
      })
    }
  }
}
